export const locale = {
    lang: 'en',
    data: {
        NO_RESULTS: 'No matches found',
        SEARCH: 'Search',
    },
};
